import { Component, EventEmitter, Input, OnChanges, ViewChild, Output, SimpleChanges } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { CustomExpansionSelectOptions } from 'src/app/core/interfaces/components/custom-expansion-select.interface';

export enum CustomExpansionSelectType {
  Select = "Select",
  Radio = "Radio",
  CheckBox = "CheckBox",
}

@Component({
    selector: 'app-custom-expansion-select',
    templateUrl: './custom-expansion-select.component.html',
    styleUrls: ['./custom-expansion-select.component.scss'],
    standalone: false
})
export class CustomExpansionSelectComponent implements OnChanges {
  @Input() label: string;
  @Input() expanded: boolean;
  @Input() disabled: boolean;
  @Input() disabledTooltip: string;
  @Input() icon: string;
  @Input() set options(value: CustomExpansionSelectOptions[]) {
    this._options = value;
    this.onOptionsChange();
  }
  _options: CustomExpansionSelectOptions[] = [
    {
      id: "1",
      name  : "Option 1"
    },
    {
      id: "2",
      name  : "Option 2"
    },
  ];
  @Input() initialSelectedOption: CustomExpansionSelectOptions | CustomExpansionSelectOptions[];
  @Input() showInfo: boolean;
  @Input() showIcon: boolean;
  @Input() type:string = CustomExpansionSelectType.Select;
  @Output() optionSelect: EventEmitter<CustomExpansionSelectOptions|CustomExpansionSelectOptions[]> = new EventEmitter<CustomExpansionSelectOptions>();
  @Output() infoClick: EventEmitter<void> = new EventEmitter<void>();

  selectedOption: CustomExpansionSelectOptions | CustomExpansionSelectOptions[];
  panelOpenState: boolean = false;

  @ViewChild(MatExpansionPanel, {static: true}) matExpansionPanelElement: MatExpansionPanel;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue === true) {
      this.panelOpenState = false;
      this.expanded = false;
      this.matExpansionPanelElement.close()
    }
  }

  onOptionsChange(): void {
    if (this.initialSelectedOption) {
      this.selectedOption = this.initialSelectedOption;
    }else{
      this.selectedOption = this.type == CustomExpansionSelectType.CheckBox ? [] : undefined;
    }
    if(this.expanded === undefined){
      //Expand if there is a selected option
      this.expanded = this.showBadge();
    }
  }

  onOptionSelect(option: CustomExpansionSelectOptions, $event=null) {
    if(this.type == CustomExpansionSelectType.CheckBox && Array.isArray(this.selectedOption)){
      if(this.selectedOption.includes(option)){
        this.selectedOption = this.selectedOption.filter((item) => item.id !== option.id);
      }else{
        this.selectedOption.push(option);
      }
    }else{
      this.selectedOption = option;
    }
    this.optionSelect.emit(this.selectedOption);
    if($event?.stopPropagation){
      $event.stopPropagation();
    }
  }

  isOptionSelected(option: CustomExpansionSelectOptions): boolean {
    if(this.selectedOption){
      if(this.type == CustomExpansionSelectType.CheckBox && Array.isArray(this.selectedOption)){
        return this.selectedOption.includes(option);
      }else if(!Array.isArray(this.selectedOption)){
        return  option.id === this.selectedOption.id;
      }
    }
    return false;
  }

  onInfoClick() {
    this.infoClick.emit();
  }

  selectedClass(option: CustomExpansionSelectOptions){
    if(this.isOptionSelected(option)){
      if(this.type == CustomExpansionSelectType.CheckBox){
        return 'select-expansion-panel-selection-list-checkbox-selected';
      } else if(this.type == CustomExpansionSelectType.Radio){
        return 'select-expansion-panel-selection-list-radio-selected';
      } else if(this.type == CustomExpansionSelectType.Select){
        return 'select-expansion-panel-selection-list-option-selected';
      }
    }

    return '';
  }

  typeClass(){
      if(this.type == CustomExpansionSelectType.CheckBox){
        return 'checkbox';
      } else if(this.type == CustomExpansionSelectType.Radio){
        return 'radio';
      } else if(this.type == CustomExpansionSelectType.Select){
        return 'select';
      }

    return '';
  }

  showBadge(){
    return !this.panelOpenState && ((Array.isArray(this.selectedOption) && this.selectedOption?.length) || (!Array.isArray(this.selectedOption) && this.selectedOption?.id))
  }

}
